'use client';
import Image from 'next/image';
import React from 'react';
import { IProduct } from '@mybestbrands/types';
import { trackSSTEvent } from '@/app/utils/tracking';
import { useTranslation } from 'next-i18next';

type Props = {
  item: IProduct;
  trackingData: object | null;
};

export const ListItemRetailerLink = ({ item, trackingData }: Props) => {
  const { t } = useTranslation(['common']);
  if (item.clickOutAllowed) {
    return (
      <div
        className="text-black-50 mt-1 d-flex align-items-center"
        onClick={() => trackSSTEvent('product_card_shop_cta_click', trackingData)}
        style={{ fontSize: '0.75rem' }}>
        {t('TO')}
        <div className="text-black ms-1 me-3">{item.retailerName}</div>
        <Image src={'/intstatic/icons/arrow-right.svg'} alt={'Link Icon'} width={8} height={12} />
      </div>
    );
  }

  return null;
};
